import { render, staticRenderFns } from "./seeClassMinsCtr.vue?vue&type=template&id=b28e5c5c&scoped=true"
import script from "./seeClassMinsCtr.vue?vue&type=script&lang=js"
export * from "./seeClassMinsCtr.vue?vue&type=script&lang=js"
import style0 from "./seeClassMinsCtr.vue?vue&type=style&index=0&id=b28e5c5c&prod&lang=less"
import style1 from "./seeClassMinsCtr.vue?vue&type=style&index=1&id=b28e5c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e5c5c",
  null
  
)

export default component.exports